import React, { useLayoutEffect, useRef, useState } from 'react';
import PlayCircleOutlineRoundedIcon from '@material-ui/icons/PlayCircleOutlineRounded';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import './helpBanner.scss';

// Temporary banner after the Sept 2026 UI revamp: points everyone to the Help
// videos. Slim and sticky at the top of every page that has the sidebar
// (not on Help itself). Closing hides it only until the page is reloaded,
// so everyone keeps seeing it while it is live.
// To remove it: set SHOW_HELP_BANNER to false (or delete this component and
// its one use in components/navBar/navBar.js).
export const SHOW_HELP_BANNER = true;

// Other sticky elements (e.g. the loan page banner) sit below it.
const HEIGHT_VAR = '--announce-h';

// Module-level so it survives moving between pages, not a reload.
let closedThisLoad = false;

export default function HelpBanner({ path = '' }) {
  const [hidden, setHidden] = useState(closedThisLoad);
  const ref = useRef(null);
  const show = SHOW_HELP_BANNER && !hidden && !path.startsWith('/help');

  // Publish the banner's real height (it wraps on narrow screens) before
  // paint, so full-height pages don't jump.
  useLayoutEffect(() => {
    const root = document.documentElement.style;
    const el = ref.current;
    if (!show || !el) {
      root.setProperty(HEIGHT_VAR, '0px');
      return undefined;
    }
    const update = () => root.setProperty(HEIGHT_VAR, `${el.offsetHeight}px`);
    update();
    const ro = window.ResizeObserver ? new ResizeObserver(update) : null;
    if (ro) ro.observe(el);
    return () => {
      if (ro) ro.disconnect();
      root.setProperty(HEIGHT_VAR, '0px');
    };
  }, [show]);

  if (!show) return null;

  const close = () => {
    closedThisLoad = true;
    setHidden(true);
  };

  return (
    <div className='bez-help-banner' ref={ref}>
      <div className='bez-help-banner-pill' role='note'>
        <PlayCircleOutlineRoundedIcon className='bez-help-banner-icon' />
        <span className='bez-help-banner-text'>
          <b>BrickEZ has a new look.</b>
          {' '}
          Watch the short how-to videos in Help to get familiar.
        </span>
        <a className='bez-help-banner-link' href='/help'>
          Open Help
          <ArrowForwardRoundedIcon />
        </a>
        <button type='button' className='bez-help-banner-close' aria-label='Close' onClick={close}>
          <CloseRoundedIcon />
        </button>
      </div>
    </div>
  );
}
